import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react';
import { HERO_IMAGES } from '../data/heroImages';

const HeroSection = forwardRef(({   title,   subtitle,   backgroundImage = '/assets/메인-섹션3배경.png',   className = '',  brandText = '한앤손 부부치과',  children }, ref) => {
  // 최적화 버전(WebP + 흐린 미리보기)이 있으면 사용
  const optimized = HERO_IMAGES[backgroundImage];
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  // 이미 받아둔 이미지(다시 방문한 페이지 등)는 화면에 그리기 전에 확인해서 바로 선명하게 표시
  useLayoutEffect(() => {
    const img = imgRef.current;
    setLoaded(Boolean(img && img.complete && img.naturalWidth > 0));
  }, [backgroundImage]);

  return (
    <div ref={ref} className={`relative h-96 flex flex-col items-center justify-center text-white ${className}`}>
      {/* 배경 이미지 */}
      <div className="absolute inset-0 overflow-hidden bg-gray-800">
        {/* 흐린 미리보기: 진짜 이미지가 도착할 때까지 바로 보여줌 */}
        {optimized && (
          <img
            src={optimized.placeholder}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover blur-xl scale-110"
          />
        )}

        {/* 진짜 이미지: 가장 먼저 받도록 우선순위를 높이고, 도착하면 부드럽게 나타남 */}
        <picture>
          {optimized && <source srcSet={optimized.webp} type="image/webp" />}
          <img
            ref={imgRef}
            src={backgroundImage}
            alt=""
            aria-hidden="true"
            fetchPriority="high"
            onLoad={() => setLoaded(true)}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
              loaded ? 'opacity-100' : 'opacity-0'
            }`}
          />
        </picture>

        {/* 어두운 오버레이 */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* 콘텐츠 */}
      <div className="relative z-10 w-full text-center px-4 max-w-4xl mx-auto">
        <div className="mb-4">
          <p className="text-lg text-gray-200 mb-2 tracking-wider">{brandText}</p>
          <h1 className="text-5xl md:text-6xl font-bold mb-4">{title}</h1>
          {subtitle && (
            <p className="text-xl text-gray-200">{subtitle}</p>
          )}
        </div>

        {/* 추가 콘텐츠 (탭 등) */}
        {children && (
          <div className="mt-8">
            {children}
          </div>
        )}
      </div>
    </div>
  );
});

HeroSection.displayName = 'HeroSection';

export default HeroSection;
